// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { ProductType } from "../../../../io/hyperify/core/store/types/product/ProductType";
import { Language } from "../../../../io/hyperify/core/types/Language";
import { SendanorProductId } from "../types/SendanorProductId";

export const DEFAULT_LANGUAGE : Language = Language.FINNISH;

export const T_PRODUCT_LIST_NO_ITEMS = 'product.list.no.items';

// footer
export const T_FOOTER_ADDRESS_TITLE                  = 'footer.address.title';
export const T_FOOTER_MAINTENANCE_24                 = 'footer.maintenance.24';
export const T_FOOTER_TITLE_SERVICES                 = 'footer.title.services';
export const T_FOOTER_TITLE_CUSTOMER_SERVICES        = 'footer.title.customer.services';
export const T_FOOTER_TITLE_LINKS                    = 'footer.title.links';
export const T_FOOTER_TITLE_TERMS_LEGALS             = 'footer.title.terms.legals';

export const T_FOOTER_TERMS_OF_DELIVERY              = 'footer.terms.of.delivery';
export const T_FOOTER_TERMS_OF_USE                   = 'footer.terms.of.use';
export const T_FOOTER_PRIVACY_POLICY                 = 'footer.privacy.policy';
export const T_FOOTER_REGISTRY_DESCRIPTION           = 'footer.registry.description';
export const T_FOOTER_COOKIES                        = 'footer.cookies';

export const T_FOOTER_DESIGN                         = 'footer.design';
export const T_FOOTER_IMPLEMENTATION                 = 'footer.implementation';
export const T_SUPPORT_INFO                          = 'footer.supportInfo';
export const T_NOTIFICATIONS                         = 'footer.notifications';
export const T_SUPPORT_EMAIL                         = 'footer.supportEmail';
export const T_SUPPORT_EMAIL_HREF                    = 'footer.supportEmailHref';
export const T_SUPPORT_PHONE                         = 'footer.supportPhone';
export const T_FOOTER_COPYRIGHT                      = 'footer.copyright';


// nav
export const T_NAV_WEBHOTELS                         = 'nav.webhotels';
export const T_NAV_VIRTUALSERVERS                    = 'nav.virtualservers';
export const T_NAV_DOMAINS                           = 'nav.domains';
export const T_NAV_SHELLS                            = 'nav.shells';
export const T_NAV_ATLAS                            = 'nav.atlas';
export const T_NAV_DATABASES                         = 'nav.databases';
export const T_NAV_EMAIL                             = 'nav.email';
export const T_NAV_WEBRTC                            = 'nav.webrtc';
export const T_NAV_WP                                = 'nav.wp';
export const T_NAV_NET                               = 'nav.net';
export const T_NAV_SOFTWARE                               = 'nav.software';
export const T_NAV_OUTLET                               = 'nav.outlet';
export const T_NAV_PREMIUM_DOMAIN                    = 'nav.premiumDomains';
export const T_NAV_IMAGES                            = 'nav.images';

export const T_ORDER_NOW                             = 'order.now';
export const T_READ_MORE                             = 'read.more';

export const T_WEBHOTELS_TELL_MORE_TITLE             = 'webhotels.tell.more.title';
export const T_WEBHOTELS_TELL_MORE_DESCRIPTION       = 'webhotels.tell.more.description';
export const T_WEBHOTELS_CONTACTS                    = 'webhotels.contacts';

export const T_VIRTUALSERVERS_FOOTER_TITLE              = 'virtualservers.footer.title';
export const T_VIRTUALSERVERS_FOOTER_DESCRIPTION        = 'virtualservers.footer.description';
export const T_VIRTUALSERVERS_FOOTER_BUTTON_TEXT        = 'virtualservers.footer.buttonText';

export const T_EMAIL_FOOTER_TITLE              = 'email.footer.title';
export const T_EMAIL_FOOTER_DESCRIPTION        = 'email.footer.description';
export const T_EMAIL_FOOTER_BUTTON_TEXT        = 'email.footer.buttonText';

export const T_VIRTUALSERVERS_FAQ_TITLE              = 'virtualservers.faq.title';
export const T_VIRTUALSERVERS_FAQ_DESCRIPTION        = 'virtualservers.faq.description';

export const T_VIRTUALSERVERS_FAQ_Q1_TITLE              = 'virtualservers.faq.q1.title';
export const T_VIRTUALSERVERS_FAQ_Q1_DESCRIPTION        = 'virtualservers.faq.q1.description';

export const T_VIRTUALSERVERS_FAQ_Q2_TITLE              = 'virtualservers.faq.q2.title';
export const T_VIRTUALSERVERS_FAQ_Q2_DESCRIPTION        = 'virtualservers.faq.q2.description';

export const T_VIRTUALSERVERS_FAQ_Q3_TITLE              = 'virtualservers.faq.q3.title';
export const T_VIRTUALSERVERS_FAQ_Q3_DESCRIPTION        = 'virtualservers.faq.q3.description';

export const T_VIRTUALSERVERS_FAQ_Q4_TITLE              = 'virtualservers.faq.q4.title';
export const T_VIRTUALSERVERS_FAQ_Q4_DESCRIPTION        = 'virtualservers.faq.q4.description';

export const T_VIRTUALSERVERS_FAQ_Q5_TITLE              = 'virtualservers.faq.q5.title';
export const T_VIRTUALSERVERS_FAQ_Q5_DESCRIPTION        = 'virtualservers.faq.q5.description';

export const T_VIRTUALSERVERS_FAQ_Q6_TITLE              = 'virtualservers.faq.q6.title';
export const T_VIRTUALSERVERS_FAQ_Q6_DESCRIPTION        = 'virtualservers.faq.q6.description';

export const T_VIRTUALSERVERS_FAQ_Q7_TITLE              = 'virtualservers.faq.q7.title';
export const T_VIRTUALSERVERS_FAQ_Q7_DESCRIPTION        = 'virtualservers.faq.q7.description';

export const T_VIRTUALSERVERS_FAQ_Q8_TITLE              = 'virtualservers.faq.q8.title';
export const T_VIRTUALSERVERS_FAQ_Q8_DESCRIPTION        = 'virtualservers.faq.q8.description';

export const T_VIRTUALSERVERS_FAQ_Q9_TITLE              = 'virtualservers.faq.q9.title';
export const T_VIRTUALSERVERS_FAQ_Q9_DESCRIPTION        = 'virtualservers.faq.q9.description';

export const T_VIRTUALSERVERS_FAQ_Q10_TITLE              = 'virtualservers.faq.q10.title';
export const T_VIRTUALSERVERS_FAQ_Q10_DESCRIPTION        = 'virtualservers.faq.q10.description';

export const T_VIRTUALSERVERS_FAQ_Q11_TITLE              = 'virtualservers.faq.q11.title';
export const T_VIRTUALSERVERS_FAQ_Q11_DESCRIPTION        = 'virtualservers.faq.q11.description';

export const T_VIRTUALSERVERS_FAQ_Q12_TITLE              = 'virtualservers.faq.q12.title';
export const T_VIRTUALSERVERS_FAQ_Q12_DESCRIPTION        = 'virtualservers.faq.q12.description';

export const T_VIRTUALSERVERS_FAQ_QUESTIONS = [
    {
        title: T_VIRTUALSERVERS_FAQ_Q12_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q12_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q1_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q1_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q2_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q2_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q3_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q3_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q4_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q4_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q5_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q5_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q6_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q6_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q7_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q7_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q8_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q8_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q9_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q9_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q10_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q10_DESCRIPTION
    },
    {
        title: T_VIRTUALSERVERS_FAQ_Q11_TITLE,
        description: T_VIRTUALSERVERS_FAQ_Q11_DESCRIPTION
    }
];

export const T_VIRTUALSERVERS_EXTRA_PRODUCTS    = 'virtualservers.extraProducts.title';
export const T_WEB_HOTEL_EXTRA_PRODUCTS         = 'web.extraProducts.title';
export const T_EMAIL_EXTRA_PRODUCTS              = 'email.extraProducts.title';
export const T_SHELL_FEATURES_TITLE         = 'shell.featureList.title';

export const T_SOFTWARE_TITLE                    = 'software.title';
export const T_SOFTWARE_INTRO                    = 'software.intro';
export const T_SOFTWARE_INTRO_READ_MORE                    = 'software.intro.readMore';
export const T_SOFTWARE_ORIGINAL_PRICE           = 'software.originalPrice';
export const T_SOFTWARE_DISCOUNT_INFO            = 'software.discountInfo';
export const T_PRODUCT_SOFTWARE_DESCRIPTION      = 'product.software.description';
export const T_SOFTWARE_FOOTER_TITLE             = 'software.footer.title';
export const T_SOFTWARE_FOOTER_DESCRIPTION       = 'software.footer.description';
export const T_SOFTWARE_FOOTER_READ_MORE         = 'software.footer.readMore';

export const T_PRODUCT_WEBHOTELS_DESCRIPTION         = 'product.webhotels.description';
export const T_PRODUCT_VIRTUALSERVERS_DESCRIPTION    = 'product.virtualservers.description';
export const T_PRODUCT_DOMAINS_DESCRIPTION           = 'product.domains.description';
export const T_PRODUCT_SHELLS_DESCRIPTION            = 'product.shells.description';
export const T_PRODUCT_ATLAS_DESCRIPTION            = 'product.atlas.description';
export const T_PRODUCT_EMAILS_DESCRIPTION            = 'product.emails.description';
export const T_PRODUCT_WORDPRESS_DESCRIPTION         = 'product.wordpress.description';
export const T_PRODUCT_WEBRTC_DESCRIPTION            = 'product.webrtc.description';
export const T_PRODUCT_NET_DESCRIPTION               = 'product.net.description';
export const T_PRODUCT_PREMIUM_DOMAIN_DESCRIPTION    = 'product.premiumDomain.description';
export const T_PRODUCT_SUPPORT_DESCRIPTION    = 'product.support.description';
export const T_PRODUCT_IMAGES_DESCRIPTION            = 'product.images.description';
// export const T_PRODUCT_DATABASES_DESCRIPTION         = 'product.databases.description';
// export const T_PRODUCT_WEBRTC_DESCRIPTION            = 'product.webrtc.description';

export const T_PRODUCT_SHELLS_EXTRA_DESCRIPTION            = 'product.shells.extra.description';

export const T_SHELLS_SEO_IMAGE_EXTRA           = 'shells.ogImageExtraText';

export const T_WEBHOTELS_TITLE                       = 'webhotels.title';
export const T_WEBHOTELS_SEO_IMAGE_EXTRA           = 'webhotels.ogImageExtraText';
export const T_WEBHOTELS_SSD                         = 'webhotels.ssd';
export const T_WEBHOTELS_GB                          = 'webhotels.gb';
export const T_WEBHOTELS_X                           = 'webhotels.x';
export const T_WEBHOTELS_BACKUPS                     = 'webhotels.backups';

export const T_WEBHOTELS_F_DOMAIN                    = 'webhotels.f.domain';
export const T_WEBHOTELS_SUBDOMAINS                  = 'webhotels.subdomains';
export const T_WEBHOTELS_DNS                         = 'webhotels.dns';
export const T_WEBHOTELS_EMAILS                      = 'webhotels.emails';
export const T_WEBHOTELS_EMAILBOXES                  = 'webhotels.emailboxes';
export const T_WEBHOTELS_FEATURES                    = 'webhotels.features';
export const T_WEBHOTELS_DOMAIN                      = 'webhotels.domain';
export const T_WEBHOTELS_HOLIDAYS                    = 'webhotels.holidays';
export const T_WEBHOTELS_FORWARDS                    = 'webhotels.forwards';
export const T_WEBHOTELS_SQUIRRELMAIL                = 'webhotels.squirrelmail';

export const T_WEBHOTELS_PRODUCT_1_TITLE        = 'webhotels.product.1.title';
export const T_WEBHOTELS_PRODUCT_1_DESCRIPTION  = 'webhotels.product.1.description';

export const T_WEBHOTELS_PRODUCT_2_TITLE        = 'webhotels.product.2.title';
export const T_WEBHOTELS_PRODUCT_2_DESCRIPTION  = 'webhotels.product.2.description';

export const T_ATLAS_PRODUCT_ATLAS_18G_TITLE        = 'atlas.product.atlas18g.title';
export const T_ATLAS_PRODUCT_ATLAS_18G_DESCRIPTION  = 'atlas.product.atlas18g.description';

export const T_WEBHOTELS_PRODUCT_TITAN_1G_TITLE        = 'webhotels.product.titan1g.title';
export const T_WEBHOTELS_PRODUCT_TITAN_1G_DESCRIPTION  = 'webhotels.product.titan1g.description';

export const T_WEBHOTELS_PRODUCT_TITAN_2G_TITLE        = 'webhotels.product.titan2g.title';
export const T_WEBHOTELS_PRODUCT_TITAN_2G_DESCRIPTION  = 'webhotels.product.titan2g.description';

export const T_WEBHOTELS_PRODUCT_TITAN_5G_TITLE        = 'webhotels.product.titan5g.title';
export const T_WEBHOTELS_PRODUCT_TITAN_5G_DESCRIPTION  = 'webhotels.product.titan5g.description';

export const T_WEBHOTELS_PRODUCT_TITAN_10G_TITLE        = 'webhotels.product.titan10g.title';
export const T_WEBHOTELS_PRODUCT_TITAN_10G_DESCRIPTION  = 'webhotels.product.titan10g.description';

export const T_WEBHOTELS_PRODUCT_TITAN_20G_TITLE        = 'webhotels.product.titan20g.title';
export const T_WEBHOTELS_PRODUCT_TITAN_20G_DESCRIPTION  = 'webhotels.product.titan20g.description';


export const T_WEBHOTELS_PRODUCT_ATLAS_2G_TITLE        = 'webhotels.product.atlas2g.title';
export const T_WEBHOTELS_PRODUCT_ATLAS_2G_DESCRIPTION  = 'webhotels.product.atlas2g.description';

export const T_WEBHOTELS_PRODUCT_ATLAS_5G_TITLE        = 'webhotels.product.atlas5g.title';
export const T_WEBHOTELS_PRODUCT_ATLAS_5G_DESCRIPTION  = 'webhotels.product.atlas5g.description';

export const T_WEBHOTELS_PRODUCT_ATLAS_10G_TITLE        = 'webhotels.product.atlas10g.title';
export const T_WEBHOTELS_PRODUCT_ATLAS_10G_DESCRIPTION  = 'webhotels.product.atlas10g.description';

export const T_WEBHOTELS_PRODUCT_ATLAS_20G_TITLE        = 'webhotels.product.atlas20g.title';
export const T_WEBHOTELS_PRODUCT_ATLAS_20G_DESCRIPTION  = 'webhotels.product.atlas20g.description';

export const T_PAY_TIME_Y                            = 'pay.time.y';
export const T_PAY_TIME_M                            = 'pay.time.m'
export const T_TIME_Y                                = 'time.y';
export const T_TIME_M                                = 'time.m';
export const T_WEBHOTELS_1000_GB                     = 'webhotels.1000.gb'
export const T_WEBHOTELS_250_MM                      = 'webhotels.250.mm'

export const T_VIRTUALSERVERS_TITLE           = 'virtualservers.title';
export const T_VIRTUALSERVERS_MAIN_TITLE           = 'virtualservers.mainTitle';
export const T_VIRTUALSERVERS_PRODUCT_LINK_TEXT           = 'virtualservers.productLinkText';
export const T_VIRTUALSERVERS_INFO_WEBSITE_LINK_TEXT           = 'virtualservers.infoWebsiteLinkText';
export const T_VIRTUALSERVERS_SEO_IMAGE_EXTRA           = 'virtualservers.ogImageExtraText';
export const T_VIRTUALSERVERS_DESCRIPTION     = "virtualservers.description";
export const T_VIRTUALSERVERS_TELL_MORE_TITLE        = "virtualservers.tell.more.title";
export const T_VIRTUALSERVERS_TELL_MORE_DESCRIPTION  = "virtualservers.tell.more.description";
export const T_VIRTUALSERVERS_CONTACTS               = "virtualservers.contacts";

export const T_VIRTUALSERVERS_PRODUCT_MINI_1_TITLE        = 'virtualservers.product.mini1.title';
export const T_VIRTUALSERVERS_PRODUCT_MINI_1_DESCRIPTION  = 'virtualservers.product.mini1.description';

export const T_VIRTUALSERVERS_PRODUCT_1_TITLE        = 'virtualservers.product.1.title';
export const T_VIRTUALSERVERS_PRODUCT_1_DESCRIPTION  = 'virtualservers.product.1.description';

export const T_VIRTUALSERVERS_PRODUCT_2_TITLE        = 'virtualservers.product.2.title';
export const T_VIRTUALSERVERS_PRODUCT_2_DESCRIPTION  = 'virtualservers.product.2.description';

export const T_VIRTUALSERVERS_PRODUCT_3_TITLE        = 'virtualservers.product.3.title';
export const T_VIRTUALSERVERS_PRODUCT_3_DESCRIPTION  = 'virtualservers.product.3.description';

export const T_VIRTUALSERVERS_PRODUCT_4_TITLE        = 'virtualservers.product.4.title';
export const T_VIRTUALSERVERS_PRODUCT_4_DESCRIPTION  = 'virtualservers.product.4.description';

export const T_VIRTUALSERVERS_PRODUCT_5_TITLE        = 'virtualservers.product.5.title';
export const T_VIRTUALSERVERS_PRODUCT_5_DESCRIPTION  = 'virtualservers.product.5.description';

export const T_VIRTUALSERVERS_PRODUCT_6_TITLE        = 'virtualservers.product.6.title';
export const T_VIRTUALSERVERS_PRODUCT_6_DESCRIPTION  = 'virtualservers.product.6.description';

export const T_VIRTUALSERVERS_PRODUCT_7_TITLE        = 'virtualservers.product.7.title';
export const T_VIRTUALSERVERS_PRODUCT_7_DESCRIPTION  = 'virtualservers.product.7.description';

export const T_VIRTUALSERVERS_PRODUCT_8_TITLE        = 'virtualservers.product.8.title';
export const T_VIRTUALSERVERS_PRODUCT_8_DESCRIPTION  = 'virtualservers.product.8.description';


export const T_VIRTUALSERVERS_PRODUCT_10_TITLE        = 'virtualservers.product.10.title';
export const T_VIRTUALSERVERS_PRODUCT_10_DESCRIPTION  = 'virtualservers.product.10.description';


export const T_VIRTUALSERVERS_PRODUCT_11_TITLE        = 'virtualservers.product.11.title';
export const T_VIRTUALSERVERS_PRODUCT_11_DESCRIPTION  = 'virtualservers.product.11.description';

export const T_VIRTUALSERVERS_PRODUCT_12_TITLE        = 'virtualservers.product.12.title';
export const T_VIRTUALSERVERS_PRODUCT_12_DESCRIPTION  = 'virtualservers.product.12.description';

export const T_VIRTUALSERVERS_PRODUCT_13_TITLE        = 'virtualservers.product.13.title';
export const T_VIRTUALSERVERS_PRODUCT_13_DESCRIPTION  = 'virtualservers.product.13.description';

export const T_VIRTUALSERVERS_PRODUCT_14_TITLE        = 'virtualservers.product.14.title';
export const T_VIRTUALSERVERS_PRODUCT_14_DESCRIPTION  = 'virtualservers.product.14.description';



export const T_DATABASES_TITLE                       = 'databases.title';
export const T_DATABASES_PRODUCT_1_DESCRIPTION       = 'databases.product.1.description';
export const T_DATABASES_PRODUCT_2_DESCRIPTION       = 'databases.product.2.description';
export const T_DATABASES_PRODUCT_3_DESCRIPTION       = 'databases.product.3.description';
export const T_DATABASES_PRODUCT_4_DESCRIPTION       = 'databases.product.4.description';

export const T_COMMON_PRODUCT_PRICE_INFO                           = 'common.product.priceInfo';

export const T_EMAIL_TITLE                           = 'email.title';
export const T_EMAIL_DESCRIPTION                     = 'email.description';
export const T_EMAIL_BOXES                           = 'email.boxes';
export const T_EMAIL_GB                              = 'email.gb';
export const T_EMAIL_DOMAINS                         = 'email.domains';
export const T_EMAIL_SUBDOMAINS                      = 'email.subdomains';
export const T_EMAIL_SUB_EMAIL                       = 'email.sub.email';
export const T_EMAIL_BACKUPS                         = 'email.backups';
export const T_EMAIL_LOCATION                        = 'email.location';
export const T_EMAIL_Q1                              = 'Verkkotunnukseni on rekisteröity muualle. Voinko ottaa pelkän sähköpostin käyttöön?';
export const T_EMAIL_Q1_DESCRIPTION                  = 'Verkkotunnus voi olla rekisteröity muualta tai käyttää eri palveluntarjoajan nimipalvelimia. Joudut silloin asettamaan DNS-asetukset verkkotunnuksellesi itse. Kerromme tarvittavat MX, DKIM, DMARC, ja SPF -tietueet, jotka tulee osata asettaa verkkotunnuksenne nimipalveluun.'

export const T_VIRTUAL_SERVER_EXTRA_TITLE        = (id: SendanorProductId) => `virtualServer.extraProduct.${id}.title`;
export const T_VIRTUAL_SERVER_EXTRA_SUMMARY  = (id: SendanorProductId) => `virtualServer.extraProduct.${id}.summary`;
export const T_VIRTUAL_SERVER_EXTRA_DESCRIPTION  = (id: SendanorProductId) => `virtualServer.extraProduct.${id}.description`;

export const T_VIRTUAL_SERVER_EXTRA_ORIGINAL_PRICE                  = 'virtualServer.extraProduct.originalPrice';
export const T_VIRTUAL_SERVER_EXTRA_DISCOUNT_INFO                   = 'virtualServer.extraProduct.discountInfo';
export const T_VIRTUAL_SERVER_EXTRA_PRICE_INFO                   = 'virtualServer.extraProduct.priceInfo';


export const T_DOMAIN_SALE_TITLE        = (id: string) => `domain.saleProduct.${id}.title`;
export const T_DOMAIN_SALE_SUMMARY  = (id: string) => `domain.saleProduct.${id}.summary`;
export const T_DOMAIN_SALE_DESCRIPTION  = (id: string) => `domain.saleProduct.${id}.description`;

export const T_DOMAIN_SALE_ORIGINAL_PRICE                  = 'domain.saleProduct.originalPrice';
export const T_DOMAIN_SALE_DISCOUNT_INFO                   = 'domain.saleProduct.discountInfo';
export const T_DOMAIN_SALE_PRICE_INFO                   = 'domain.saleProduct.priceInfo';

export const T_SOFTWARE_PRODUCT_TITLE        = (id: string) => `software.product.${id}.title`;
export const T_SOFTWARE_PRODUCT_SUMMARY  = (id: string) => `software.product.${id}.summary`;

export const T_OUTLET_TITLE                          = 'outlet.title';
export const T_OUTLET_LEGEND                          = 'outlet.legend';
export const T_OUTLET_DESCRIPTION                          = 'outlet.description';

export const T_OUTLET_PRODUCT_TITLE        = (id: string) => `outlet.product.${id}.title`;
export const T_OUTLET_PRODUCT_SUMMARY  = (id: string) => `outlet.product.${id}.summary`;
export const T_OUTLET_PRODUCT_DESCRIPTION  = (id: string) => `outlet.product.${id}.description`;

export const T_OUTLET_PRODUCT_ORIGINAL_PRICE                  = 'outlet.product.originalPrice';
export const T_OUTLET_PRODUCT_DISCOUNT_INFO                   = 'outlet.product.discountInfo';
export const T_OUTLET_PRODUCT_PRICE_INFO                   = 'outlet.product.priceInfo';


export const T_WEB_EXTRA_TITLE        = (id: SendanorProductId) => `web.extraProduct.${id}.title`;
export const T_WEB_EXTRA_SUMMARY  = (id: SendanorProductId) => `web.extraProduct.${id}.summary`;
export const T_WEB_EXTRA_DESCRIPTION  = (id: SendanorProductId) => `web.extraProduct.${id}.description`;
export const T_WEB_EXTRA_ORIGINAL_PRICE                  = 'web.extraProduct.originalPrice';
export const T_WEB_EXTRA_DISCOUNT_INFO                   = 'web.extraProduct.discountInfo';
export const T_WEB_EXTRA_PRICE_INFO                   = 'web.extraProduct.priceInfo';

export const T_ATLAS_EXTRA_TITLE        = (id: SendanorProductId) => `atlas.extraProduct.${id}.title`;
export const T_ATLAS_EXTRA_SUMMARY  = (id: SendanorProductId) => `atlas.extraProduct.${id}.summary`;
export const T_ATLAS_EXTRA_DESCRIPTION  = (id: SendanorProductId) => `atlas.extraProduct.${id}.description`;
export const T_ATLAS_EXTRA_ORIGINAL_PRICE                  = 'atlas.extraProduct.originalPrice';
export const T_ATLAS_EXTRA_DISCOUNT_INFO                   = 'atlas.extraProduct.discountInfo';
export const T_ATLAS_EXTRA_PRICE_INFO                   = 'atlas.extraProduct.priceInfo';

export const T_EMAIL_EXTRA_TITLE        = (id: SendanorProductId) => `email.extraProduct.${id}.title`;
export const T_EMAIL_EXTRA_SUMMARY  = (id: SendanorProductId) => `email.extraProduct.${id}.summary`;
export const T_EMAIL_EXTRA_DESCRIPTION  = (id: SendanorProductId) => `email.extraProduct.${id}.description`;
export const T_EMAIL_EXTRA_ORIGINAL_PRICE                  = 'email.extraProduct.originalPrice';
export const T_EMAIL_EXTRA_DISCOUNT_INFO                   = 'email.extraProduct.discountInfo';
export const T_EMAIL_EXTRA_PRICE_INFO                   = 'email.extraProduct.priceInfo';

export const T_NET_EXTRA_TITLE        = (id: SendanorProductId) => `net.extraProduct.${id}.title`;
export const T_NET_EXTRA_DESCRIPTION  = (id: SendanorProductId) => `net.extraProduct.${id}.description`;

export const T_SOFTWARE_GOVM_PRODUCT_1_TITLE        = 'software.product.1.title';
export const T_SOFTWARE_GOVM_PRODUCT_1_SUMMARY  = 'software.product.1.summary';

export const T_SOFTWARE_GOVM_PRODUCT_2_TITLE        = 'software.product.2.title';
export const T_SOFTWARE_GOVM_PRODUCT_2_SUMMARY  = 'software.product.2.summary';

export const T_SHELL_PRODUCT_1_TITLE        = 'shell.product.1.title';
export const T_SHELL_PRODUCT_1_SUMMARY  = 'shell.product.1.summary';

export const T_SHELL_PRODUCT_2_TITLE        = 'shell.product.2.title';
export const T_SHELL_PRODUCT_2_SUMMARY  = 'shell.product.2.summary';
export const T_SHELL_PRODUCT_2_DESCRIPTION  = 'shell.product.2.description';

export const T_ATLAS_PRODUCT_1_TITLE        = 'atlas.product.1.title';
export const T_ATLAS_PRODUCT_1_DESCRIPTION  = 'atlas.product.1.description';

export const T_WEBRTC_PRODUCT_1_TITLE        = 'webrtc.product.1.title';
export const T_WEBRTC_PRODUCT_1_DESCRIPTION  = 'webrtc.product.1.description';

export const T_EMAIL_PRODUCT_MINI_TITLE        = 'email.product.mini.title';
export const T_EMAIL_PRODUCT_MINI_DESCRIPTION  = 'email.product.mini.description';

export const T_EMAIL_PRODUCT_1_TITLE        = 'email.product.1.title';
export const T_EMAIL_PRODUCT_1_DESCRIPTION  = 'email.product.1.description';

export const T_EMAIL_PRODUCT_2_TITLE        = 'email.product.2.title';
export const T_EMAIL_PRODUCT_2_DESCRIPTION  = 'email.product.2.description';

export const T_EMAIL_PRODUCT_3_TITLE        = 'email.product.3.title';
export const T_EMAIL_PRODUCT_3_DESCRIPTION  = 'email.product.3.description';


export const T_NAV_CUSTOMER_SERVICE                  = 'nav.customer.services';
export const T_NAV_NEWSLETTERS                       = 'nav.newsletters';

export const T_SITE_NAME                             = 'site.name';

export const T_FOOTER_TITLE                           = 'footer.title';
export const T_FOOTER_DESCRIPTION                           = 'footer.description';

export const T_STATISTICS_TEXT                           = 'about.statisticsText';

export const T_ABOUT_TITLE                           = 'about.title';
export const T_ABOUT_DESCRIPTION                     = 'about.description';
export const T_ABOUT_INTRO                           = 'about.intro';

export const T_INTRO_TITLE                           = 'intro.title';
export const T_INTRO_WEBSITE                         = 'intro.website';
export const T_INTRO_HOSTING                         = 'intro.hosting';
export const T_INTRO_DEVELOP                         = 'intro.develop';
export const T_INTRO_FUTURE                          = 'intro.future';
export const T_INTRO_ORDER_NOW                       = 'intro.orderNow';
export const T_INTRO_READ_MORE                       = 'intro.readMore';

export const T_PALVELINKAUPPA_TITLE                           = 'palvelinkauppa.title';
export const T_PALVELINKAUPPA_WEBSITE                         = 'palvelinkauppa.website';
export const T_PALVELINKAUPPA_HOSTING                         = 'palvelinkauppa.hosting';
export const T_PALVELINKAUPPA_DEVELOP                         = 'palvelinkauppa.develop';
export const T_PALVELINKAUPPA_FUTURE                          = 'palvelinkauppa.future';
export const T_PALVELINKAUPPA_READ_MORE                       = 'palvelinkauppa.readMore';

export const T_SOLD_OUT                       = 'common.soldOut';

export const T_SHELL_FOOTER_TITLE      = 'shell.footer.title';
export const T_SHELL_FOOTER_DESCRIPTION      = 'shell.footer.description';
export const T_SHELL_FOOTER_READ_MORE        = 'shell.footer.readMore';

export const T_WEB_HOTEL_FOOTER_TITLE      = 'web.footer.title';
export const T_WEB_HOTEL_FOOTER_DESCRIPTION      = 'web.footer.description';
export const T_WEB_HOTEL_FOOTER_READ_MORE        = 'web.footer.readMore';

export const T_MOVE_NOW                              = 'move.site';

export const T_SHELL_TITLE                           = 'shell.title';
export const T_SHELL_ORIGINAL_PRICE                  = 'shell.originalPrice';
export const T_SHELL_DISCOUNT_INFO                   = 'shell.discountInfo';
export const T_SHELL_INTRO                           = 'shell.intro';

export const T_SHELL_EXTRA_TITLE                           = 'shell.extra.title';

export const T_SHELL_FEATURE_TITLE = (id: string) => `shell.features.${id}.title`;
export const T_SHELL_FEATURE_SUMMARY = (id: string) => `shell.features.${id}.summary`;
export const T_SHELL_FEATURE_DESCRIPTION = (id: string) => `shell.features.${id}.description`;

export const T_ATLAS_TITLE                           = 'atlas.title';
export const T_ATLAS_ORIGINAL_PRICE                  = 'atlas.originalPrice';
export const T_ATLAS_DISCOUNT_INFO                   = 'atlas.discountInfo';
export const T_ATLAS_INTRO                           = 'atlas.intro';


export const T_WEBRTC_TITLE                           = 'webrtc.title';
export const T_WEBRTC_WEBSITE                         = 'webrtc.website';
export const T_WEBRTC_HOSTING                         = 'webrtc.hosting';
export const T_WEBRTC_ORIGINAL_PRICE                  = 'webrtc.originalPrice';
export const T_WEBRTC_DISCOUNT_INFO                   = 'webrtc.discountInfo';
export const T_WEBRTC_INTRO                           = 'webrtc.intro';

export const T_PREMIUM_DOMAIN_TITLE                           = 'premiumDomain.title';
export const T_PREMIUM_DOMAIN_WEBSITE                         = 'premiumDomain.website';
export const T_PREMIUM_DOMAIN_HOSTING                         = 'premiumDomain.hosting';
export const T_PREMIUM_DOMAIN_INTRO                           = 'premiumDomain.intro';

export const T_PHOTOS_TITLE                           = 'photos.title';
export const T_PHOTOS_WEBSITE                         = 'photos.website';
export const T_PHOTOS_HOSTING                         = 'photos.hosting';
export const T_PHOTOS_INTRO                           = 'photos.intro';

export const T_WP_TITLE                           = 'wp.title';
export const T_WP_WEBSITE                         = 'wp.website';
export const T_WP_HOSTING                         = 'wp.hosting';
export const T_WP_DISCOUNTS                       = 'wp.discounts';
export const T_WP_INTRO                           = 'wp.intro';
export const T_WP_ORDER_NOW                       = 'wp.orderNow';

export const T_NET_TITLE                           = 'net.title';
export const T_NET_WEBSITE                         = 'net.website';
export const T_NET_HOSTING                         = 'net.hosting';
export const T_NET_DISCOUNTS                         = 'net.discounts';
export const T_NET_INTRO                           = 'net.intro';
export const T_NET_ORDER_NOW                       = 'net.orderNow';

export const T_CUSTOMER_SERVICE_TITLE                = "customerService.title";
export const T_CUSTOMER_SERVICE_CONTENT              = 'customerService.content';
export const T_CUSTOMER_SERVICE_TEXT_CONTENT              = 'customerService.textContent';
export const T_CUSTOMER_SERVICE_BUTTON_TEXT                = "customerService.buttonText";

export const T_CUSTOMER_SERVICE_CUSTOM_SOLUTIONS_TITLE                = "customerService.customSolutions.title";
export const T_CUSTOMER_SERVICE_CUSTOM_SOLUTIONS_CONTENT                = "customerService.customSolutions.content";

export const T_CUSTOMER_SERVICE_SERVICES_TITLE                = "customerService.services.title";
export const T_CUSTOMER_SERVICE_SERVICES_CONTENT                = "customerService.services.content";

export const T_CUSTOMER_SERVICE_IT_CONSULTING_TITLE                = "customerService.itConsulting.title";
export const T_CUSTOMER_SERVICE_IT_CONSULTING_CONTENT                = "customerService.itConsulting.content";

export const T_CUSTOMER_SERVICE_CLOUD_CONSULTING_TITLE                = "customerService.cloudConsulting.title";
export const T_CUSTOMER_SERVICE_CLOUD_CONSULTING_CONTENT                = "customerService.cloudConsulting.content";

export const T_CUSTOMER_SERVICE_GLOBAL_PARTNER_TITLE                = "customerService.globalPartner.title";
export const T_CUSTOMER_SERVICE_GLOBAL_PARTNER_CONTENT                = "customerService.globalPartner.content";

export const T_CUSTOMER_SERVICE_SOFTWARE_CONSULTING_TITLE                = "customerService.softwareConsulting.title";
export const T_CUSTOMER_SERVICE_SOFTWARE_CONSULTING_CONTENT                = "customerService.softwareConsulting.content";
export const T_CUSTOMER_SERVICE_FOOTER_CONTENT                = "customerService.footer.content";


export const T_CART_VIEW_TITLE                       = "cartView.title";
export const T_CART_TOTAL_SUM                        = "cartView.totalSum.label";
export const T_CART_TOTAL_SUM_WITHOUT_VAT            = "cartView.totalSumWithoutVat.label";
export const T_CART_TOTAL_VAT                        = "cartView.totalVat.label";
export const T_CART_VIEW_CONTENT                     = 'cartView.content';
export const T_CART_VIEW_NO_ITEMS_CONTENT            = 'cartView.noItemsContent';
export const T_CART_VIEW_ORDER_BUTTON_LABEL          = "cartView.orderButton.label";

export const T_DOMAIN_TITLE                          = 'domains.title';
export const T_DOMAIN_DESCRIPTION                    = 'domains.description';
export const T_DOMAIN_SEARCH_FIELD_LABEL             = 'domains.search.label';
export const T_DOMAIN_SEARCH_FIELD_PLACEHOLDER       = 'domains.search.placeholder';

export const T_DOMAIN_1                              = 'domain_1';
export const T_DOMAIN_2                              = 'domain_2';
export const T_DOMAIN_3                              = 'domain_3';
export const T_DOMAIN_EU_COMPANY                     = 'domain.eu.company';
export const T_DOMAIN_FI_COM_NET_ORG_INFO            = 'domain.fi.com.net.org.info';
export const T_DOMAIN_ME_APP                         = 'domain.me.app';
export const T_DOMAIN_INTRO                          = 'domains.intro';
export const T_DOMAIN_OTHERS                         = 'domains.others';
export const T_DOMAIN_INCLUDE                        = 'domains.include';

export const T_READ_ALL_NEWSLETTER                   = 'read.all.newsletter';

export const T_ALL_FEATURES = "allFeatures.show";
export const T_ALL_EXTRA_FEATURES = "allExtraFeatures.show";
export const T_HIDE_ALL_FEATURES = "allFeatures.hide";

export const T_CURRENCY_EURO    = 'common.currency.eur';
export const T_COMMON_PRICE_EUR = "common.price.eur";
export const T_COMMON_PRICE_WITH_PERIOD_EUR = "common.priceWithPeriod.eur";
export const T_COMMON_PRICE_EUR_LINE_2 = "common.price.eur.line2";
export const T_COMMON_PRICE_EUR_LINE_3 = "common.price.eur.line3";

export const T_DISCOUNT_ORIGINAL_PRICE_WITH_PERIOD_EUR = "discount.original.priceWithPeriod.eur";
export const T_DISCOUNT_ORIGINAL_PRICE_EUR_LINE_2 = "discount.original.price.eur.line2";
export const T_DISCOUNT_ORIGINAL_PRICE_EUR_LINE_3 = "discount.original.price.eur.line3";

export const T_DISCOUNT_PRICE_WITH_PERIOD_BUTTON_EUR = "discount.priceWithPeriod.buttonEur";
export const T_DISCOUNT_PRICE_WITH_PERIOD_EUR = "discount.priceWithPeriod.eur";
export const T_DISCOUNT_PRICE_EUR_LINE_2 = "discount.price.eur.line2";
export const T_DISCOUNT_PRICE_EUR_LINE_3 = "discount.price.eur.line3";

export const T_INDEX_ROUTE_TITLE = 'index.title';
export const T_INDEX_ROUTE_DESCRIPTION = 'index.description';

export const T_ATLAS_ROUTE_TITLE = 'atlas.index.title';
export const T_ATLAS_ROUTE_DESCRIPTION = 'atlas.index.description';

export const T_DOMAINS_ROUTE_TITLE = 'domains.index.title';
export const T_DOMAINS_ROUTE_DESCRIPTION = 'domains.index.description';

export const T_EMAILS_ROUTE_TITLE = 'email.index.title';
export const T_EMAILS_ROUTE_DESCRIPTION = 'email.index.description';

export const T_IMAGES_ROUTE_TITLE = 'images.index.title';
export const T_IMAGES_ROUTE_DESCRIPTION = 'images.index.description';

export const T_WEBHOTELS_ROUTE_TITLE = 'webhotels.index.title';
export const T_WEBHOTELS_ROUTE_DESCRIPTION = 'webhotels.index.description';

export const T_VIRTUALSERVERS_ROUTE_TITLE = 'virtualservers.index.title';
export const T_VIRTUALSERVERS_ROUTE_DESCRIPTION = 'virtualservers.index.description';

export const T_PREMIUM_DOMAINS_ROUTE_TITLE = 'premiumDomain.index.title';
export const T_PREMIUM_DOMAINS_ROUTE_DESCRIPTION = 'premiumDomain.index.description';

export const T_NEWSLETTER_ROUTE_TITLE = 'newsletter.index.title';
export const T_NEWSLETTER_ROUTE_DESCRIPTION = 'newsletter.index.description';

export const T_NET_ROUTE_TITLE = 'net.index.title';
export const T_NET_ROUTE_DESCRIPTION = 'net.index.description';

export const T_WORDPRESS_ROUTE_TITLE = 'wordpress.index.title';
export const T_WORDPRESS_ROUTE_DESCRIPTION = 'wordpress.index.description';

export const T_PRIVACY_POLICY_ROUTE_TITLE = 'privacyPolicy.index.title';
export const T_PRIVACY_POLICY_ROUTE_DESCRIPTION = 'privacyPolicy.index.description';

export const T_WEBRTC_ROUTE_TITLE = 'webrtc.index.title';
export const T_WEBRTC_ROUTE_DESCRIPTION = 'webrtc.index.description';

export const T_SHELLS_ROUTE_TITLE = 'shells.index.title';
export const T_SHELLS_ROUTE_DESCRIPTION = 'shells.index.description';

export const T_TERMS_OF_USE_ROUTE_TITLE = 'termsOfUse.index.title';
export const T_TERMS_OF_USE_ROUTE_DESCRIPTION = 'termsOfUse.index.description';

export const T_TERMS_OF_DELIVERY_ROUTE_TITLE = 'termsOfDelivery.index.title';
export const T_TERMS_OF_DELIVERY_ROUTE_DESCRIPTION = 'termsOfDelivery.index.description';

export const T_NOT_FOUND_ROUTE_TITLE = 'notFound.title';
export const T_NOT_FOUND_ROUTE_DESCRIPTION = 'notFound.description';

export const T_RESELLER_ROUTE_TITLE = 'reseller.title';
export const T_RESELLER_ROUTE_DESCRIPTION = 'reseller.description';

export const T_REGISTRY_DESCRIPTION_ROUTE_TITLE = 'registryDescription.title';
export const T_REGISTRY_DESCRIPTION_ROUTE_DESCRIPTION = 'registryDescription.description';


export const T_COOKIES_VIEW_TITLE   = "cookiesView.title";
export const T_COOKIES_VIEW_META_TITLE   = "cookiesView.meta.title";
export const T_COOKIES_VIEW_META_CONTENT   = "cookiesView.meta.content";
export const T_COOKIES_VIEW_META_LINK_TEXT   = "cookiesView.meta.privacyLinkText";
export const T_COOKIES_VIEW_DESCRIPTION   = "cookiesView.description";
export const T_COOKIES_VIEW_CONTENT = "cookiesView.content";
export const T_COOKIES_VIEW_ACCEPT_ALL = "cookiesView.acceptAll";
export const T_COOKIES_VIEW_ACCEPT_ALL_TIP = "cookiesView.acceptAllTip";
export const T_COOKIES_VIEW_ACCEPT_MANDATORY = "cookiesView.acceptMandatory";
export const T_COOKIES_VIEW_ACCEPT_MANDATORY_TIP = "cookiesView.acceptMandatoryTip";

export const T_AGENT_FACEBOOK_VIEW_TITLE   = "agent.facebook.title";
export const T_AGENT_FACEBOOK_VIEW_DESCRIPTION   = "agent.facebook.description";
export const T_AGENT_FACEBOOK_VIEW_CONTENT = "agent.facebook.content";

export const T_MY_REQUEST_CODE_CODE_FIELD_PLACEHOLDER = "my.requestCode.codeField.placeholder";
export const T_MY_REQUEST_CODE_BUTTON_LABEL           = "my.requestCode.buttonLabel";
export const T_MY_REQUEST_CODE_ERROR_MESSAGE          = "my.requestCode.errorMessage";
export const T_MY_REQUEST_CODE_CODE_FIELD_LABEL       = "my.requestCode.codeField.label";

export const T_MY_LOGIN_VIEW_REQUEST_CODE_TITLE                  = "myLogin.requestCode.title";
export const T_MY_LOGIN_VIEW_REQUEST_TEXT                        = "myLogin.requestCode.text";

export const T_MY_ORDER_VIEW_REQUEST_CODE_TITLE                  = "myOrder.requestCode.title";
export const T_MY_ORDER_VIEW_REQUEST_TEXT                        = "myOrder.requestCode.text";

export const T_MY_REQUEST_EMAIL_BUTTON_LABEL       = "my.requestEmail.buttonLabel";
export const T_MY_REQUEST_EMAIL_ALTERNATIVE_BUTTON_LABEL       = "my.requestEmail.alternativeButtonLabel";
export const T_MY_REQUEST_EMAIL_FIELD_LABEL        = "my.requestEmail.field.label";
export const T_MY_REQUEST_EMAIL_FIELD_PLACEHOLDER  = "my.requestEmail.field.placeholder";
export const T_MY_REQUEST_EMAIL_ERROR_MESSAGE      = "my.requestEmail.errorMessage";

export const T_MY_REQUEST_SMS_BUTTON_LABEL       = "my.requestSms.buttonLabel";
export const T_MY_REQUEST_SMS_ALTERNATIVE_BUTTON_LABEL       = "my.requestSms.alternativeButtonLabel";
export const T_MY_REQUEST_SMS_FIELD_LABEL        = "my.requestSms.field.label";
export const T_MY_REQUEST_SMS_FIELD_PLACEHOLDER  = "my.requestSms.field.placeholder";
export const T_MY_REQUEST_SMS_ERROR_MESSAGE      = "my.requestSms.errorMessage";

export const T_MY_LOGIN_VIEW_TITLE                    = "myLogin.title";
export const T_MY_LOGIN_VIEW_TEXT                     = "myLogin.text";
export const T_MY_LOGIN_VIEW_SUBMIT_BUTTON_LABEL       = "myLogin.buttonLabel";

export const T_MY_ORDER_VIEW_LOGIN_TITLE                    = "myOrder.unauthorized.title";
export const T_MY_ORDER_VIEW_LOGIN_TEXT                     = "myOrder.unauthorized.text";
export const T_MY_ORDER_VIEW_LOGIN_SUBMIT_BUTTON_LABEL       = "myOrder.unauthorized.buttonLabel";

export const T_MY_ORDER_VIEW_AUTHORIZED_TITLE = "myOrder.authorized.title";
export const T_MY_ORDER_VIEW_AUTHORIZED_TEXT  = "myOrder.authorized.text";

export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_CLIENT_TYPE_TITLE = "myOrder.newClient.clientType.title";
export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_CLIENT_TYPE_BACK_BUTTON_LABEL  = "myOrder.newClient.clientType.backButtonLabel";
export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_CLIENT_TYPE_SUBMIT_BUTTON_LABEL  = "myOrder.newClient.clientType.submitButtonLabel";

export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_ADDRESS_TITLE = "myOrder.newClient.address.title";
export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_ADDRESS_BACK_BUTTON_LABEL  = "myOrder.newClient.address.backButtonLabel";
export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_ADDRESS_SUBMIT_BUTTON_LABEL  = "myOrder.newClient.address.submitButtonLabel";

export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_EMAIL_TITLE = "myOrder.newClient.email.title";
export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_PHONE_TITLE = "myOrder.newClient.phone.title";
export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_PHONE_BACK_BUTTON_LABEL  = "myOrder.newClient.phone.backButtonLabel";
export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_PHONE_SUBMIT_BUTTON_LABEL  = "myOrder.newClient.phone.submitButtonLabel";

export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_SUBMIT_ERROR_TITLE = "myOrder.newClient.submitError.title";
export const T_MY_ORDER_VIEW_NEW_CLIENT_STEP_SUBMIT_ERROR_TEXT  = "myOrder.newClient.submitError.text";

export const T_MY_ORDER_VIEW_NEW_CLIENT_TITLE = "myOrder.newClient.title";
export const T_MY_ORDER_VIEW_NEW_CLIENT_TEXT  = "myOrder.newClient.text";
export const T_MY_ORDER_VIEW_NEW_CLIENT_COMPANY_FIELD_TEXT  = "myOrder.newClient.companyFieldText";

export const T_MY_ORDER_VIEW_NEW_CLIENT_SUBMIT_BUTTON_LABEL  = "myOrder.newClient.submitButtonLabel";

export const T_MY_ORDER_VIEW_SELECT_CLIENT_TITLE = "myOrder.selectClient.title";
export const T_MY_ORDER_VIEW_SELECT_CLIENT_TEXT  = "myOrder.selectClient.text";
export const T_MY_ORDER_VIEW_SELECT_CLIENT_OTHER_TEXT    = "myOrder.selectClient.otherText";
export const T_MY_ORDER_VIEW_SELECT_CLIENT_BACK_BUTTON   = "myOrder.selectClient.backButton";
export const T_MY_ORDER_VIEW_SELECT_CLIENT_SELECT_ANY_CLIENT_LABEL   = "myOrder.selectClient.selectAnyClientLabel";
export const T_MY_ORDER_VIEW_SELECT_CLIENT_NEW_COMPANY   = "myOrder.selectClient.newCompany";
export const T_MY_ORDER_VIEW_SELECT_CLIENT_NEW_PERSON    = "myOrder.selectClient.newPerson";
export const T_MY_ORDER_VIEW_SELECT_CLIENT_SELECT_OTHER  = "myOrder.selectClient.selectOther";

export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_TITLE = "myOrder.confirmSelectedClient.title";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_ERROR_MESSAGE = "myOrder.confirmSelectedClient.errorMessage";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_BACK_BUTTON   = "myOrder.confirmSelectedClient.backButton";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_SUBMIT_BUTTON  = "myOrder.confirmSelectedClient.submitButton";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_NAME_LABEL = "myOrder.confirmSelectedClient.nameLabel";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_BUSINESS_NAME_LABEL = "myOrder.confirmSelectedClient.businessNameLabel";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_BUSINESS_ID_LABEL = "myOrder.confirmSelectedClient.businessIdLabel";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_ID_LABEL = "myOrder.confirmSelectedClient.idLabel";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_EMAIL_LABEL = "myOrder.confirmSelectedClient.emailLabel";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_PHONE_LABEL = "myOrder.confirmSelectedClient.phoneLabel";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_MOBILE_LABEL = "myOrder.confirmSelectedClient.mobileLabel";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_ADDRESS_LABEL = "myOrder.confirmSelectedClient.addressLabel";
export const T_MY_ORDER_VIEW_CONFIRM_SELECTED_CLIENT_CART_LABEL = "myOrder.confirmSelectedClient.cartLabel";

export const T_MY_INVENTORY_LIST_VIEW_TITLE = "myInventoryListView.title";
export const T_MY_INVENTORY_LIST_VIEW_NO_CLIENT = "myInventoryListView.noClient";
export const T_MY_INVENTORY_LIST_VIEW_NO_RESULTS_FOUND = "myInventoryListView.noResultsFound";
export const T_MY_INVENTORY_LIST_VIEW_TABLE_INVENTORY_ID_LABEL = "myInventoryListView.table.labels.orderId";
export const T_MY_INVENTORY_LIST_VIEW_TABLE_SUMMARY_LABEL = "myInventoryListView.table.labels.summary";
export const T_MY_INVENTORY_LIST_VIEW_TABLE_STATE_LABEL = "myInventoryListView.table.labels.state";
export const T_MY_INVENTORY_LIST_VIEW_TABLE_TIME_LABEL = "myInventoryListView.table.labels.time";
export const T_MY_INVENTORY_LIST_VIEW_TABLE_END_TIME_LABEL = "myInventoryListView.table.labels.endTime";

export const T_MY_PAYMENT_LIST_VIEW_TITLE = "myPaymentListView.title";
export const T_MY_PAYMENT_LIST_VIEW_NO_CLIENT = "myPaymentListView.noClient";
export const T_MY_PAYMENT_LIST_VIEW_NO_RESULTS_FOUND = "myPaymentListView.noResultsFound";
export const T_MY_PAYMENT_LIST_VIEW_TABLE_PAYMENT_ID_LABEL = "myPaymentListView.table.labels.paymentId";
export const T_MY_PAYMENT_LIST_VIEW_TABLE_DESCRIPTION_LABEL = "myPaymentListView.table.labels.description";
export const T_MY_PAYMENT_LIST_VIEW_TABLE_EXTRA_NOTICE_LABEL = "myPaymentListView.table.labels.extraNotice";
export const T_MY_PAYMENT_LIST_VIEW_TABLE_START_DATE_LABEL = "myPaymentListView.table.labels.startDate";
export const T_MY_PAYMENT_LIST_VIEW_TABLE_END_DATE_LABEL = "myPaymentListView.table.labels.endDate";

export const T_MY_PAYMENT_VIEW_TITLE = "myPaymentView.title";
export const T_MY_PAYMENT_VIEW_NO_RESULTS_FOUND = "myPaymentView.noResultsFound";
export const T_MY_PAYMENT_VIEW_PAYMENT_ID_LABEL = "myPaymentView.fields.paymentId.label";
export const T_MY_PAYMENT_VIEW_INVOICE_ID_LABEL = "myPaymentView.fields.invoiceId.label";
export const T_MY_PAYMENT_VIEW_AMOUNT_LABEL = "myPaymentView.fields.amount.label";
export const T_MY_PAYMENT_VIEW_PRICE_LABEL = "myPaymentView.fields.price.label";
export const T_MY_PAYMENT_VIEW_VAT_PERCENT_LABEL = "myPaymentView.fields.vatPercent.label";
export const T_MY_PAYMENT_VIEW_DISCOUNT_PERCENT_LABEL = "myPaymentView.fields.discountPercent.label";
export const T_MY_PAYMENT_VIEW_START_DATE_LABEL = "myPaymentView.fields.startDate.label";
export const T_MY_PAYMENT_VIEW_END_DATE_LABEL = "myPaymentView.fields.endDate.label";
export const T_MY_PAYMENT_VIEW_DUE_DATE_LABEL = "myPaymentView.fields.dueDate.label";
export const T_MY_PAYMENT_VIEW_DESCRIPTION_LABEL = "myPaymentView.fields.description.label";
export const T_MY_PAYMENT_VIEW_EXTRA_NOTICE_LABEL = "myPaymentView.fields.extraNotice.label";

export const T_MY_ORDER_LIST_VIEW_TITLE = "myOrderListView.title";
export const T_MY_ORDER_LIST_VIEW_NO_RESULTS_FOUND = "myOrderListView.noResultsFound";
export const T_MY_ORDER_LIST_VIEW_TABLE_ORDER_ID_LABEL = "myOrderListView.table.labels.orderId";
export const T_MY_ORDER_LIST_VIEW_TABLE_TIME_LABEL = "myOrderListView.table.labels.time";
export const T_MY_ORDER_LIST_VIEW_TABLE_STATUS_LABEL = "myOrderListView.table.labels.status";

export const T_MY_INVOICE_LIST_VIEW_TITLE = "myInvoiceListView.title";
export const T_MY_INVOICE_LIST_VIEW_NO_RESULTS_FOUND = "myInvoiceListView.noResultsFound";
export const T_MY_INVOICE_LIST_VIEW_TABLE_INVOICE_ID_LABEL = "myInvoiceListView.table.labels.orderId";
export const T_MY_INVOICE_LIST_VIEW_TABLE_TIME_LABEL = "myInvoiceListView.table.labels.time";
export const T_MY_INVOICE_LIST_VIEW_TABLE_DUE_DATE_LABEL = "myInvoiceListView.table.labels.dueDate";
export const T_MY_INVOICE_LIST_VIEW_TABLE_STATUS_LABEL = "myInvoiceListView.table.labels.status";
export const T_MY_INVOICE_LIST_VIEW_TABLE_UNPAID_LABEL = "myInvoiceListView.table.labels.unpaid";
export const T_MY_INVOICE_LIST_VIEW_TABLE_STATUS_PAID = "myInvoiceListView.table.values.status.paid";
export const T_MY_INVOICE_LIST_VIEW_TABLE_STATUS_UNPAID = "myInvoiceListView.table.values.status.unpaid";
export const T_MY_INVOICE_LIST_VIEW_TABLE_STATUS_CANCELLED = "myInvoiceListView.table.values.status.cancelled";


export const T_MY_INVOICE_VIEW_TITLE = "myInvoiceView.title";
export const T_MY_INVOICE_VIEW_PAYMENT_IBAN_TITLE = "myInvoiceView.payment.iban.title";
export const T_MY_INVOICE_VIEW_PAYMENT_FOOTER_DETAILS = "myInvoiceView.payment.footer.details";
export const T_MY_INVOICE_VIEW_PAYMENT_IBAN_DETAILS_TITLE = "myInvoiceView.payment.iban.details";
export const T_MY_INVOICE_VIEW_PAYMENT_PAYTRAIL_TITLE = "myInvoiceView.payment.paytrail.title";
export const T_MY_INVOICE_VIEW_PAYMENT_PROVIDER_TITLE = "myInvoiceView.payment.provider.title";
export const T_MY_INVOICE_VIEW_PAYMENT_GROUP_BACK_BUTTON = "myInvoiceView.payment.selectGroup.backButtonText";
export const T_MY_INVOICE_VIEW_PAYMENT_GROUP_SUBMIT_BUTTON = "myInvoiceView.payment.selectGroup.submitText";
export const T_MY_INVOICE_VIEW_PAYMENT_PROVIDER_SUBMIT_BUTTON = "myInvoiceView.payment.selectProvider.submitText";
export const T_MY_INVOICE_VIEW_NO_RESULTS_FOUND = "myInvoiceView.noResultFound";
export const T_MY_INVOICE_VIEW_INVOICE_ID_LABEL = "myInvoiceView.labels.invoiceId";
export const T_MY_INVOICE_VIEW_REFERENCE_NUMBER_LABEL = "myInvoiceView.labels.referenceNumber";

export const T_MY_INVOICE_VIEW_STATE_LABEL = "myInvoiceView.labels.state";
export const T_MY_INVOICE_VIEW_TOTAL_SUM_LABEL = "myInvoiceView.labels.totalSum";
export const T_MY_INVOICE_VIEW_TOTAL_VAT_LABEL = "myInvoiceView.labels.totalVat";
export const T_MY_INVOICE_VIEW_TOTAL_SUM_INCLUDING_VAT_LABEL = "myInvoiceView.labels.totalSumIncludingVat";
export const T_MY_INVOICE_VIEW_TOTAL_PAID_LABEL = "myInvoiceView.labels.totalPaid";
export const T_MY_INVOICE_VIEW_TOTAL_OPEN_LABEL = "myInvoiceView.labels.totalOpen";
export const T_MY_INVOICE_VIEW_IBAN_LABEL = "myInvoiceView.labels.iban";
export const T_MY_INVOICE_VIEW_BIC_LABEL = "myInvoiceView.labels.bic";
export const T_MY_INVOICE_VIEW_BANK_NAME_LABEL = "myInvoiceView.labels.bankName";

export const T_MY_INVOICE_VIEW_TO_PAYMENT_SERVICE_BUTTON_LABEL = "myInvoiceView.toPaymentServiceButton.label";
export const T_MY_INVOICE_VIEW_ROWS_LABEL = "myInvoiceView.labels.rows";
export const T_MY_INVOICE_VIEW_DATE_LABEL = "myInvoiceView.labels.date";
export const T_MY_INVOICE_VIEW_DUE_DATE_LABEL = "myInvoiceView.labels.dueDate";
export const T_MY_INVOICE_VIEW_ROW_LABEL_DESCRIPTION = "myInvoiceView.row.labels.description";
export const T_MY_INVOICE_VIEW_ROW_LABEL_START_DATE = "myInvoiceView.row.labels.startDate";
export const T_MY_INVOICE_VIEW_ROW_LABEL_END_DATE = "myInvoiceView.row.labels.endDate";
export const T_MY_INVOICE_VIEW_ROW_LABEL_AMOUNT_DATE = "myInvoiceView.row.labels.amount";
export const T_MY_INVOICE_VIEW_ROW_LABEL_PRICE_DATE = "myInvoiceView.row.labels.price";
export const T_MY_INVOICE_VIEW_ROW_LABEL_VAT_PERCENT_DATE = "myInvoiceView.row.labels.vatPercent";
export const T_MY_INVOICE_VIEW_ROW_LABEL_INVENTORY_BUTTON = "myInvoiceView.row.labels.inventoryButton";

export const T_MY_INVENTORY_ITEM_VIEW_TITLE = "myInventoryItemView.title";
export const T_MY_INVENTORY_ITEM_VIEW_NO_RESULTS_FOUND = "myInventoryItemView.noResultFound";
export const T_MY_INVENTORY_ITEM_VIEW_INVENTORY_ITEM_ID_LABEL = "myInventoryItemView.labels.inventoryItemId";
export const T_MY_INVENTORY_ITEM_VIEW_STATE_LABEL = "myInventoryItemView.labels.state";
export const T_MY_INVENTORY_ITEM_VIEW_DATE_LABEL = "myInventoryItemView.labels.date";
export const T_MY_INVENTORY_ITEM_VIEW_END_DATE_LABEL = "myInventoryItemView.labels.endDate";
export const T_MY_INVENTORY_ITEM_VIEW_SUMMARY_LABEL = "myInventoryItemView.labels.summary";
export const T_MY_INVENTORY_ITEM_VIEW_SAVING_ERROR_MESSAGE = "myInventoryItemView.savingErrorMessage";

export const T_TIME_FORMAT = "common.timeFormat";
export const T_DATE_TIME_FORMAT = "common.dateTimeFormat";
export const T_DATE_FORMAT = "common.dateFormat";
export const T_COMMON_OPEN = "common.open";
export const T_COMMON_OR = "common.or";

export const T_MY_CLIENT_VIEW_TITLE = "myClientView.title";
export const T_MY_CLIENT_VIEW_NO_CLIENT_FOUND_ERROR_MESSAGE = "myClientView.noClientFoundErrorMessage";
export const T_MY_CLIENT_VIEW_NAME_LABEL = "myClientView.nameLabel";
export const T_MY_CLIENT_VIEW_BUSINESS_NAME_LABEL = "myClientView.businessNameLabel";
export const T_MY_CLIENT_VIEW_BUSINESS_ID_LABEL = "myClientView.businessIdLabel";
export const T_MY_CLIENT_VIEW_ID_LABEL = "myClientView.idLabel";
export const T_MY_CLIENT_VIEW_EMAIL_LABEL = "myClientView.emailLabel";
export const T_MY_CLIENT_VIEW_PHONE_LABEL = "myClientView.phoneLabel";
export const T_MY_CLIENT_VIEW_MOBILE_LABEL = "myClientView.mobileLabel";
export const T_MY_CLIENT_VIEW_ADDRESS_LABEL = "myClientView.addressLabel";

export const T_MY_DASHBOARD_MENU_CLIENT_LIST_LABEL = "myDashboardMenu.clientList";
export const T_MY_DASHBOARD_MENU_LOGIN_LABEL = "myDashboardMenu.login";
export const T_MY_DASHBOARD_MENU_CLIENT_LABEL = "myDashboardMenu.client";
export const T_MY_DASHBOARD_MENU_INVOICE_LIST_LABEL = "myDashboardMenu.invoiceList";
export const T_MY_DASHBOARD_MENU_PAYMENT_LIST_LABEL = "myDashboardMenu.paymentList";
export const T_MY_DASHBOARD_MENU_INVENTORY_LIST_LABEL = "myDashboardMenu.inventoryList";
export const T_MY_DASHBOARD_MENU_ORDER_LIST_LABEL = "myDashboardMenu.orderList";

export const T_MY_ORDER_VIEW_COMPLETE_TITLE = "myOrder.complete.title";
export const T_MY_ORDER_VIEW_COMPLETE_NO_CLIENT_FOUND_TITLE = "myOrder.complete.noClientFoundTitle";
export const T_MY_ORDER_VIEW_COMPLETE_NO_CLIENT_FOUND_TEXT = "myOrder.complete.noClientFoundTitle";
export const T_MY_ORDER_VIEW_COMPLETE_NAME_LABEL = "myOrder.complete.nameLabel";
export const T_MY_ORDER_VIEW_COMPLETE_BUSINESS_NAME_LABEL = "myOrder.complete.businessNameLabel";
export const T_MY_ORDER_VIEW_COMPLETE_BUSINESS_ID_LABEL = "myOrder.complete.businessIdLabel";
export const T_MY_ORDER_VIEW_COMPLETE_ID_LABEL = "myOrder.complete.idLabel";
export const T_MY_ORDER_VIEW_COMPLETE_EMAIL_LABEL = "myOrder.complete.emailLabel";
export const T_MY_ORDER_VIEW_COMPLETE_PHONE_LABEL = "myOrder.complete.phoneLabel";
export const T_MY_ORDER_VIEW_COMPLETE_MOBILE_LABEL = "myOrder.complete.mobileLabel";
export const T_MY_ORDER_VIEW_COMPLETE_ADDRESS_LABEL = "myOrder.complete.addressLabel";
export const T_MY_ORDER_VIEW_COMPLETE_CART_LABEL = "myOrder.complete.cartLabel";

export const T_MY_ORDER_VIEW_NO_CLIENT_FOUND_TITLE = "myOrder.noClientFound.title";
export const T_MY_ORDER_VIEW_NO_CLIENT_FOUND_TEXT  = "myOrder.noClientFound.text";
export const T_MY_ORDER_VIEW_NO_CLIENT_SELECT_COMPANY  = "myOrder.noClientFound.selectCompany";
export const T_MY_ORDER_VIEW_NO_CLIENT_SELECT_PERSON  = "myOrder.noClientFound.selectPerson";
export const T_MY_ORDER_VIEW_NO_CLIENT_SELECT_OTHER  = "myOrder.noClientFound.selectOther";

export const T_MY_ORDER_VIEW_NO_CART_TITLE = "myOrder.noCart.title";
export const T_MY_ORDER_VIEW_NO_CART_TEXT  = "myOrder.noCart.text";

export const T_NEW_CLIENT_FIELD_COMPANY_LABEL       = 'newClient.fieldLabel.company';
export const T_NEW_CLIENT_FIELD_COMPANY_CODE_LABEL  = 'newClient.fieldLabel.companyCode';
export const T_NEW_CLIENT_FIELD_FIRSTNAME_LABEL     = 'newClient.fieldLabel.firstname';
export const T_NEW_CLIENT_FIELD_LASTNAME_LABEL      = 'newClient.fieldLabel.lastname';
export const T_NEW_CLIENT_FIELD_ADDRESS_LABEL       = 'newClient.fieldLabel.address';
export const T_NEW_CLIENT_FIELD_POSTCODE_LABEL      = 'newClient.fieldLabel.postcode';
export const T_NEW_CLIENT_FIELD_POST_NAME_LABEL     = 'newClient.fieldLabel.postName';
export const T_NEW_CLIENT_FIELD_COUNTRY_LABEL       = 'newClient.fieldLabel.country';
export const T_NEW_CLIENT_FIELD_EMAIL_LABEL         = 'newClient.fieldLabel.email';
export const T_NEW_CLIENT_FIELD_PHONE_LABEL         = 'newClient.fieldLabel.phone';
export const T_NEW_CLIENT_FIELD_MOBILE_LABEL        = 'newClient.fieldLabel.mobile';

export const T_MY_CLIENT_LIST_VIEW_TITLE = "myClientList.title";

export const T_INVENTORY_ITEM_STATE_PREFIX       = "inventoryItem.state";

export const T_MY_SHELL_INVENTORY_DATA_INCORRECT_DATA = "myInventoryData.shell.incorrectData";
export const T_MY_SHELL_INVENTORY_DATA_RESET_LABEL       = "myInventoryData.shell.resetLabel";
export const T_MY_SHELL_INVENTORY_DATA_STATE_LABEL       = "myInventoryData.shell.stateLabel";
export const T_MY_SHELL_INVENTORY_DATA_SAVE_LABEL       = "myInventoryData.shell.saveLabel";
export const T_MY_SHELL_INVENTORY_DATA_APPROVE_LABEL       = "myInventoryData.shell.approveLabel";
export const T_MY_SHELL_INVENTORY_DATA_FIELD_HOSTNAME_LABEL = "myInventoryData.shell.fields.hostname.label";
export const T_MY_SHELL_INVENTORY_DATA_FIELD_PORT_LABEL = "myInventoryData.shell.fields.port.label";
export const T_MY_SHELL_INVENTORY_DATA_FIELD_USERNAME_LABEL = "myInventoryData.shell.fields.username.label";
export const T_MY_SHELL_INVENTORY_DATA_FIELD_USERNAME_PLACEHOLDER = "myInventoryData.shell.fields.username.placeholder";
export const T_MY_SHELL_INVENTORY_DATA_FIELD_REAL_NAME_LABEL = "myInventoryData.shell.fields.realName.label";
export const T_MY_SHELL_INVENTORY_DATA_FIELD_REAL_NAME_DISCLAIMER = "myInventoryData.shell.fields.realName.disclaimer";

export const T_MY_ATLAS_INVENTORY_DATA_INCORRECT_DATA       = "myInventoryData.atlas.incorrectData";
export const T_MY_ATLAS_INVENTORY_DATA_RESET_LABEL       = "myInventoryData.atlas.resetLabel";
export const T_MY_ATLAS_INVENTORY_DATA_STATE_LABEL       = "myInventoryData.atlas.stateLabel";
export const T_MY_ATLAS_INVENTORY_DATA_SAVE_LABEL       = "myInventoryData.atlas.saveLabel";
export const T_MY_ATLAS_INVENTORY_DATA_APPROVE_LABEL       = "myInventoryData.atlas.approveLabel";
export const T_MY_ATLAS_INVENTORY_DATA_FIELD_HOSTNAME_LABEL = "myInventoryData.atlas.fields.hostname.label";
export const T_MY_ATLAS_INVENTORY_DATA_FIELD_PORT_LABEL = "myInventoryData.atlas.fields.port.label";
export const T_MY_ATLAS_INVENTORY_DATA_FIELD_USERNAME_LABEL = "myInventoryData.atlas.fields.username.label";
export const T_MY_ATLAS_INVENTORY_DATA_FIELD_USERNAME_PLACEHOLDER = "myInventoryData.atlas.fields.username.placeholder";
export const T_MY_ATLAS_INVENTORY_DATA_FIELD_REAL_NAME_LABEL = "myInventoryData.atlas.fields.realName.label";

export const T_MY_EMAIL_INVENTORY_DATA_INCORRECT_DATA       = "myInventoryData.email.incorrectData";
export const T_MY_EMAIL_INVENTORY_DATA_RESET_LABEL       = "myInventoryData.email.resetLabel";
export const T_MY_EMAIL_INVENTORY_DATA_STATE_LABEL       = "myInventoryData.email.stateLabel";
export const T_MY_EMAIL_INVENTORY_DATA_SAVE_LABEL       = "myInventoryData.email.saveLabel";
export const T_MY_EMAIL_INVENTORY_DATA_APPROVE_LABEL       = "myInventoryData.email.approveLabel";
export const T_MY_EMAIL_INVENTORY_DATA_FIELD_HOSTNAME_LABEL = "myInventoryData.email.fields.hostname.label";
export const T_MY_EMAIL_INVENTORY_DATA_FIELD_USERNAME_LABEL = "myInventoryData.email.fields.username.label";
export const T_MY_EMAIL_INVENTORY_DATA_FIELD_USERNAME_PLACEHOLDER = "myInventoryData.email.fields.username.placeholder";

export const T_MY_VIRTUAL_SERVER_INVENTORY_DATA_INCORRECT_DATA       = "myInventoryData.virtualServer.incorrectData";
export const T_MY_VIRTUAL_SERVER_INVENTORY_DATA_RESET_LABEL       = "myInventoryData.virtualServer.resetLabel";
export const T_MY_VIRTUAL_SERVER_INVENTORY_DATA_STATE_LABEL       = "myInventoryData.virtualServer.stateLabel";
export const T_MY_VIRTUAL_SERVER_INVENTORY_DATA_SAVE_LABEL       = "myInventoryData.virtualServer.saveLabel";
export const T_MY_VIRTUAL_SERVER_INVENTORY_DATA_APPROVE_LABEL       = "myInventoryData.virtualServer.approveLabel";
export const T_MY_VIRTUAL_SERVER_INVENTORY_DATA_FIELD_SYSTEM_LABEL = "myInventoryData.virtualServer.fields.system.label";
export const T_MY_VIRTUAL_SERVER_INVENTORY_DATA_FIELD_NAME_LABEL = "myInventoryData.virtualServer.fields.name.label";
export const T_MY_VIRTUAL_SERVER_INVENTORY_DATA_FIELD_NAME_PLACEHOLDER = "myInventoryData.virtualServer.fields.name.placeholder";

export const T_MY_WEB_HOTEL_INVENTORY_DATA_INCORRECT_DATA       = "myInventoryData.webHotel.incorrectData";
export const T_MY_WEB_HOTEL_INVENTORY_DATA_RESET_LABEL       = "myInventoryData.webHotel.resetLabel";
export const T_MY_WEB_HOTEL_INVENTORY_DATA_STATE_LABEL       = "myInventoryData.webHotel.stateLabel";
export const T_MY_WEB_HOTEL_INVENTORY_DATA_SAVE_LABEL       = "myInventoryData.webHotel.saveLabel";
export const T_MY_WEB_HOTEL_INVENTORY_DATA_APPROVE_LABEL       = "myInventoryData.webHotel.approveLabel";
export const T_MY_WEB_HOTEL_INVENTORY_DATA_FIELD_SYSTEM_LABEL = "myInventoryData.webHotel.fields.system.label";
export const T_MY_WEB_HOTEL_INVENTORY_DATA_FIELD_NAME_LABEL = "myInventoryData.webHotel.fields.name.label";
export const T_MY_WEB_HOTEL_INVENTORY_DATA_FIELD_NAME_PLACEHOLDER = "myInventoryData.webHotel.fields.name.placeholder";

export const T_MY_DOMAIN_INVENTORY_DATA_INCORRECT_DATA       = "myInventoryData.domain.incorrectData";
export const T_MY_DOMAIN_INVENTORY_DATA_RESET_LABEL       = "myInventoryData.domain.resetLabel";
export const T_MY_DOMAIN_INVENTORY_DATA_STATE_LABEL       = "myInventoryData.domain.stateLabel";
export const T_MY_DOMAIN_INVENTORY_DATA_SAVE_LABEL       = "myInventoryData.domain.saveLabel";
export const T_MY_DOMAIN_INVENTORY_DATA_APPROVE_LABEL       = "myInventoryData.domain.approveLabel";
export const T_MY_DOMAIN_INVENTORY_DATA_FIELD_SYSTEM_LABEL = "myInventoryData.domain.fields.system.label";
export const T_MY_DOMAIN_INVENTORY_DATA_FIELD_NAME_LABEL = "myInventoryData.domain.fields.name.label";

export const T_MY_DOMAIN_TRANSFER_INVENTORY_DATA_INCORRECT_DATA      = "myInventoryData.domainTransfer.incorrectData";
export const T_MY_DOMAIN_TRANSFER_INVENTORY_DATA_RESET_LABEL         = "myInventoryData.domainTransfer.resetLabel";
export const T_MY_DOMAIN_TRANSFER_INVENTORY_DATA_STATE_LABEL         = "myInventoryData.domainTransfer.stateLabel";
export const T_MY_DOMAIN_TRANSFER_INVENTORY_DATA_SAVE_LABEL          = "myInventoryData.domainTransfer.saveLabel";
export const T_MY_DOMAIN_TRANSFER_INVENTORY_DATA_APPROVE_LABEL       = "myInventoryData.domainTransfer.approveLabel";
export const T_MY_DOMAIN_TRANSFER_INVENTORY_DATA_FIELD_SYSTEM_LABEL  = "myInventoryData.domainTransfer.fields.system.label";
export const T_MY_DOMAIN_TRANSFER_INVENTORY_DATA_FIELD_NAME_LABEL    = "myInventoryData.domainTransfer.fields.name.label";
export const T_MY_DOMAIN_TRANSFER_INVENTORY_DATA_FIELD_AUTH_ID_LABEL = "myInventoryData.domainTransfer.fields.authId.label";

export const T_COOKIE_CONSENT_ARTICLE_TITLE = "cookieConsent.title";
export const T_COOKIE_CONSENT_ARTICLE_CONTENT = "cookieConsent.content";
export const T_COOKIE_CONSENT_ACCEPT_ALL_BUTTON_LABEL = "cookieConsent.acceptAllButton.label";
export const T_COOKIE_CONSENT_ACCEPT_MANDATORY_BUTTON_LABEL = "cookieConsent.acceptMandatoryButton.label";
export const T_COOKIE_CONSENT_REMOVE_CONSENT = "cookieConsent.removeConsent.label";
export const T_COOKIE_CONSENT_ACCEPT_ALL_SELECTED_TEXT = "cookieConsent.acceptedAllText";
export const T_COOKIE_CONSENT_ACCEPT_MANDATORY_SELECTED_TEXT = "cookieConsent.acceptedMandatoryText";
export const T_COOKIE_CONSENT_SETTINGS_BUTTON_LABEL = "cookieConsent.settingsButtonLabel";

export const T_DOMAIN_PRODUCT_SUMMARY = (type: ProductType) : string => {
    return `domain.summary.${type}`;
}

export const T_DOMAIN_PRODUCT_DESCRIPTION = (type: ProductType) : string => {
    return `domain.description.${type}`;
}
